import React, { useRef, useEffect, useState } from "react";
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import VideosPopUp from "../videos-popup/videos-popup";
import "./videos-carousel.scss";

const VideosCarousel = ({ actualVideo, setActualVideo, videos }) => {
  const carouselRef = useRef();
  const scrollStep = 200;
  const [actualIndex, setActualIndex] = useState(0);
  const [showPopUp, setShowPopUp] = useState(false);

  const scrollCarousel = (direction) => {
    const carousel = carouselRef.current;
    const newActualIndex = videos
      .map((video) => video.image)
      .indexOf(actualVideo.image);
    if (direction === "left") {
      setActualIndex(newActualIndex - 1);
      setActualIndex(newActualIndex === 0 ? 0 : newActualIndex - 1);
      setActualVideo(
        newActualIndex === 0 ? videos[0] : videos[newActualIndex - 1]
      );
      const valueToScroll =
        carousel.scrollLeft - scrollStep < 0
          ? 0
          : carousel.scrollLeft - scrollStep;
      carousel.scroll(valueToScroll, 0);
    } else {
      setActualIndex(
        newActualIndex === videos.length - 1
          ? videos.length - 1
          : newActualIndex + 1
      );
      setActualVideo(
        newActualIndex === videos.length - 1
          ? videos[videos.length - 1]
          : videos[newActualIndex + 1]
      );
      const valueToScroll =
        carousel.scrollLeft + scrollStep >= carousel.scrollWidth
          ? carousel.scrollWidth
          : carousel.scrollLeft + scrollStep;
      carousel.scroll(valueToScroll, 0);
    }
  };
  const compClass = "o-carousel-videos";
  const updateActualVideo = (video, index) => {
    setActualVideo(video);
    setActualIndex(index);
  };
  useEffect(() => {
    setActualVideo(videos[0]);
  }, []);

  return (
    <>
      <VideosPopUp
        setShowPopUp={setShowPopUp}
        showPopUp={showPopUp}
        actualVideo={actualVideo}
      />
      <div className={compClass}>
        <div className={`${compClass}-left`}>
          <span>
            Videos
            <br />
            <b>más recientes</b>
          </span>
          <div className={`${compClass}__arrows`}>
            <FaLongArrowAltLeft onClick={() => scrollCarousel("left")} />
            <FaLongArrowAltRight onClick={() => scrollCarousel("right")} />
          </div>
        </div>
        <div ref={carouselRef} className={`${compClass}-right`}>
          {videos.map((video, index) => (
            <div
              key={index}
              onClick={() => updateActualVideo(video, index)}
              className={`${compClass}__iframeWrapper ${
                index === actualIndex
                  ? `${compClass}__iframeWrapper-active`
                  : ""
              } `}
            >
              <img
                src={video?.imagen || video?.image}
                alt={`${video?.imagen || video?.image}-${index}`}
                onClick={() => setShowPopUp(true)}
              />
              <div className={`${compClass}__iframeWrapper__text`}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: video?.titulo || "Titulo",
                  }}
                  onClick={() => setShowPopUp(true)}
                ></span>
                <p>{video?.span || "Span"}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default VideosCarousel;
